import type { Contract } from '@mobi/web-native-comms'
import { isReactNativeApp, sendToNative } from '@mobi/web-native-comms/web'
import { isHapticFeedbackSettingEnabled } from '@core/Areas/Settings/Store/selectors'
import { store } from '@core/Store'

export const triggerHapticFeedback = (
  feedbackType: Contract['START_HAPTIC_FEEDBACK'] = 'impact-light'
) => {
  const isHapticEnabled = isHapticFeedbackSettingEnabled(store.getState())

  if (!isHapticEnabled) return

  // Trigger haptic feedback
  if (isReactNativeApp) {
    sendToNative('START_HAPTIC_FEEDBACK', feedbackType)
  } else {
    window.navigator.vibrate?.(feedbackType == 'success' ? 50 : 25)
  }
}
